import React, { useState } from 'react';
import { SettingOutlined } from '@ant-design/icons';
import { Tabs } from '@clockout-dev/design-elements';
import VolumeTiersPanel from './volumeTiersPanel/VolumeTiersPanel';
import ProductTypesPanel from './ProductTypesPanel';
import FreeAdvancesTab from './freeAdvances/FreeAdvancesTab';
import { ADVANCED_FEE_TAB_KEYS, ADVANCED_FEE_TABS } from '../feeStructureForm.constants';
import styles from '../styles/feeStructureForm.module.scss';
import ConfigurationCard from '../../../../common/configurationCard/ConfigurationCard';

/**
 * Container for the three advanced fee sub-tabs. The active tab key is
 * pure presentational state (kept local). The panels themselves consume
 * pre-cooked bundles from their controllers — VolumeTiers comes through
 * `panels.volumeTiers` (sub-controller); the other two still get
 * `rules` + `handlers` directly until they grow their own controllers.
 */
function AdvancedFeeConfigCard({ rules = {}, handlers = {}, panels = {} }) {
    const [activeKey, setActiveKey] = useState(ADVANCED_FEE_TAB_KEYS.VOLUME_TIERS);

    const panel = {
        [ADVANCED_FEE_TAB_KEYS.VOLUME_TIERS]: <VolumeTiersPanel {...(panels.volumeTiers || {})} />,
        [ADVANCED_FEE_TAB_KEYS.PRODUCT_TYPES]: (
            <ProductTypesPanel
                rules={rules.productTypeRules}
                onAdd={handlers.addProductTypeRule}
                onRemove={handlers.removeProductTypeRule}
                onUpdate={handlers.updateProductTypeRule}
            />
        ),
        [ADVANCED_FEE_TAB_KEYS.FREE_ADVANCES]: (
            <FreeAdvancesTab rules={rules} handlers={handlers} panels={panels} />
        )
    };

    return (
        <ConfigurationCard
            title="Advanced Fee Configurations"
            icon={<SettingOutlined />}
        >
            <Tabs
                activeKey={activeKey}
                onChange={setActiveKey}
                items={ADVANCED_FEE_TABS.map((tab) => ({ key: tab.key, label: tab.label }))}
                className={styles.advancedTabs}
            />
            {panel[activeKey]}
        </ConfigurationCard>
    );
}

export default AdvancedFeeConfigCard;
